module.exports = __webpack_public_path__ + "img/Soloviev.e073d46f.png";